import React from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Careers.css';

const Careers = () => {
  const navigate = useNavigate();

  const handleApply = (position) => {
    console.log('Apply button clicked for position:', position);
    const url = `/careers/apply/${position.title.toLowerCase().replace(/\s+/g, '-')}`;
    console.log('Navigating to:', url);
    navigate(url, { 
      state: { position } 
    });
  };

  const positions = [
    {
      title: "Senior Developer – Integration & ERP Implementationss",
      department: "Engineering",
      location: "Hybrid (Noida, India)",
      type: "Full-time",
      description: "Lead the development, design, and deployment of complex integration solutions across ERP, CRM, and third-party systems.",
      responsibilities: [
        "Lead the design and implementation of robust and scalable integration solutions using middleware platforms such as Dell Boomi, Mulesoft anypoint Platform, and Azure Integration Services",
        "Architect and develop API-driven integration frameworks to enable real-time and batch data exchange across enterprise systems",
        "Collaborate with cross-functional stakeholders to gather business and functional requirements and convert them into technical integration solutions",
        "Develop, deploy, and maintain custom integrations between ERP (SAP, Oracle, Microsoft Dynamics) and CRM platforms like Salesforce",
        "Customize and implement Salesforce connectors, manage data synchronization processes, and ensure alignment with enterprise CRM and ERP ecosystems",
        "Participate in full-cycle ERP implementations, including middleware configuration, security compliance, and data flow design",
        "Ensure adherence to data governance, enterprise security, and best practices in integration design and architecture",
        "Monitor integration interfaces for performance, reliability, and availability, ensuring proactive issue resolution and continuous optimization",
        "Document technical specifications, configuration changes, and architectural decisions for long-term maintainability"
      ],
      requirements: {
        education: "Bachelor's degree in computer science, Information Technology, Software Engineering, or related field",
        experience: "Minimum 4 years of progressive experience in software development, with at least 2 years in integration architecture and ERP implementation",
        technicalSkills: {
          integrationPlatforms: ["Dell Boomi (AtomSphere)", "Mulesoft Anypoint Platform", "Azure Logic Apps", "Azure API Management", "Azure Service Bus"],
          erpSystems: ["SAP", "Oracle ERP Cloud", "Microsoft Dynamics 365"],
          crmSystems: ["Salesforce (Sales Cloud, Service Cloud) – including custom object integration, data mapping, and workflow automation"],
          languages: ["XML", "JSON", "REST", "SOAP", "Java", "JavaScript", "SQL"],
          cloudPlatforms: ["Microsoft Azure (Azure Functions, Storage, Key Vault, DevOps Pipelines)"],
          otherTools: ["Postman", "Swagger", "Git", "Jenkins", "JIRA", "Confluence"]
        },
        travel: "May require travel to client sites within the U.S. depending on project scope"
      }
    }
    // },
    // {
    //   title: "Cloud Solutions Architect",
    //   department: "Architecture",
    //   location: "Remote",
    //   type: "Full-time"
    // },
    // {
    //   title: "DevOps Engineer",
    //   department: "Operations",
    //   location: "Remote",
    //   type: "Full-time"
    // }
  ];

  return (
    <div className="careers-page">
      <Header />
      
      {/* Hero Section */}
      <motion.section 
        className="careers-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="hero-content">
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Join Our Team of Innovators
          </motion.h1>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            Be part of a team that's shaping the future of enterprise technology
          </motion.p>
        </div>
      </motion.section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <h2>Why Join CyntraLabs?</h2>
        <div className="benefits-grid">
          {[
            {
              title: "Innovation First",
              description: "Work with cutting-edge technologies and shape the future of enterprise solutions"
            },
            {
              title: "Growth & Learning",
              description: "Continuous learning opportunities and career development programs"
            },
            {
              title: "Work-Life Balance",
              description: "Flexible work arrangements and emphasis on personal well-being"
            },
            {
              title: "Global Impact",
              description: "Work on projects that transform businesses worldwide"
            },
            {
              title: "Inclusive Culture",
              description: "Diverse, collaborative environment where every voice matters"
            },
            {
              title: "Competitive Benefits",
              description: "Comprehensive benefits package and performance recognition"
            }
          ].map((benefit, index) => (
            <motion.div 
              key={index}
              className="benefit-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Open Positions Section */}
      <section className="positions-section">
        <h2>Open Positions</h2>
        <div className="positions-grid">
          {positions.map((position, index) => (
            <motion.div 
              key={index}
              className="position-card"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h3>{position.title}</h3>
              <div className="position-meta">
                <span>{position.department}</span>
                <span>{position.location}</span>
                <span>{position.type}</span>
              </div>
              <p className="position-description">{position.description}</p>
              <button 
                onClick={() => handleApply(position)} 
                className="apply-btn"
              >
                Apply Now
              </button>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="careers-cta">
        <h2>Don't see the right position?</h2>
        <p>We're always looking for talented individuals to join our team</p>
        <Link to="/Get-In-Touch" className="cta-btn">
          Contact Us
        </Link>
      </section>

      <Footer />
    </div>
  );
};

export default Careers; 